<!--图片裁剪框-->
<template>
  <div class="dialog">
      <div class="model">
        <h3>上传封面<span class="fr close" @click="cancelCrop">×</span></h3>
        <p class="crop-info">建议尺寸：800x600或以上</p>
        <div class="crop-box clearfix">
            <div class="fl left">
                <div class="cropper">
                    <vueCropper
                        v-show="options.img"
                        ref="cropper"
                        :img="options.img"
                        :outputType="options.outputType"
                        :autoCrop="options.autoCrop"
                        :autoCropWidth="options.autoCropWidth"
                        :autoCropHeight="options.autoCropHeight"
                        :fixed="options.fixed"
                        :fixedNumber="options.fixedNumber"
                        :fixedBox="options.fixedBox"
                        :centerBox="options.centerBox"
                        @realTime="realPrev"
                    ></vueCropper>
                    <label v-show="!options.img">
                        <div class="df left-up">
                            <div>
                                <div class="add">+</div>
                                <p>上传封面</p>
                            </div>
                            <div class="ft12">
                                <p>只支持JPG/PNG，大小不超过5M</p>
                                <p>建议尺寸为800X600</p>
                            </div>
                        </div>
                        <input type="file" class="file" id="file" @change="chooseFile" accept="image/jpg,image/png,image/jpeg,image/gif"/>
                    </label>
                </div>
                <div class="handle clearfix">
                    <span class="fl re-up" @click="reChoose">重新上传</span>
                    <div class="fr">
                        <span class="handle-icon enlarge" @click="changeScale(1)"></span>
                        <span class="handle-icon shrink" @click="changeScale(-1)"></span>
                        <span class="handle-icon rotate" @click="rotateRight"></span>
                    </div>
                </div>
            </div>
            <div class="fr right">
                <div class="prev">
                    <div class="prev-box">
                        <div :style="previewStyle"> 
                            <div :style="previews.div">
                                <img :src="previews.url" :style="previews.img">
                            </div>
                        </div>
                    </div>
                    <div v-if="userInfo">
                        <p class="title">{{userInfo.Title}}</p>
                        <div class="num-box">
                            <img src="../../assets/img/comment_icon.png" alt="" class="icon"> {{userInfo.CommentNum}}
                            <img src="../../assets/img/zan_icon.png" alt="" class="icon2"> {{userInfo.LoveNum}}
                        </div>
                        <div class="df info">
                            <img :src="userInfo.Avatar" alt="" class="user-img">
                            <span class="user-text">No.{{userInfo.JobNo}}</span>
                            <span class="user-text user-name">{{userInfo.NickName}}</span> 
                            <span v-if="userInfo.isSend">已发布</span>
                            <span v-if="!userInfo.isSend">未发布</span>
                        </div>
                    </div>
                </div>
                <p>封面预览</p>
            </div>
        </div>
        <div class="df btn-box">
            <div class="btn btn-sure" @click="getResult">确定</div>
            <div class="btn btn-cancel" @click="cancelCrop">取消</div>
        </div>
      </div>
      <Warn ref="warn"></Warn>
  </div>
</template>
<script>
import Warn from "../common/warn"
export default {
  components: {
    Warn
  },
  data(){
      return {
          options: {
            img: "",
            outputType: "png",   //剪切后输出的图片格式
            canScale: true,       //是否允许滚轮缩放,
            autoCrop: true,       //是否默认生成截图框
            autoCropWidth: 240,   //默认截图框宽度
            autoCropHeight: 180,  //默认截图框高度
            fixed: true,          //是否开启截图框固定宽度比例
            fixedNumber: [4,3],   //截图框比例
            fixedBox: false,       //固定截图框大小
            centerBox: true,      //截图框是否被限制在图片里面
          },
          previews: {},         //预览对象
          previewStyle: {},     //预览样式
          userInfo: {
            Id: "",
            JobNo: "",
            NickName: "王某",
            Avatar: "",
            Title: "",    //标题 
            CommentNum:  0,   //评论数
            LoveNum: 0,       //点赞数
            isSend: false,      //是否发布
          },
          cropWidth: 0,     //截图框宽度
          cropHeight: 0,     //截图框高度,
          resultUrl: "",     //裁剪之后的url
      }
  },
  mounted(){
      this.cropWidth = this.$refs.cropper.cropW ? this.$refs.cropper.cropW : 0;
      this.cropHeight = this.$refs.cropper.cropH ? this.$refs.cropper.cropH : 0;
      this.getUserInfo();
  },
  methods: {
      //获取用户信息
      getUserInfo(){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.userInfo.Id = userInfo.Id;
        this.userInfo.JobNo = userInfo.JobNo;
        this.userInfo.NickName = userInfo.NickName;
        this.userInfo.Avatar = userInfo.Avatar;
      },
      //获取文章信息
      getArticleInfo(data){
        this.userInfo.Title = data.Title;
        this.userInfo.CommentNum = data.CommentNumbers;
        this.userInfo.LikeNumbers = data.LikeNumbers;
        this.userInfo.isSend = data.Id ? true: false;
      },
      //选择图片    需做验证,是否为图片,图片大小验证
      chooseFile(el){
          var that = this;
          var file = el.target.files[0] || "";
          if(!file) return;
          if(!this.testImg(file)){
              //提示选择图片
              this.$refs.warn.message("请选择图片!");
              el.target.value = "";
              return;
          }
          if(file.size>(1024*1024*5)){
              //提示图片大小超去范围
              this.$refs.warn.message("图片大小不能超过5M!");
              el.target.value = "";
              return;
          }
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function(){
                var url = this.result;
                that.options.img = url;
            }
      },
      //重新选择
      reChoose(){
          document.getElementById("file").click();
      },
      //实时预览
      realPrev(data){
          this.previews = data;
          this.previewStyle = {
              width: this.previews.w + "px",
              height: this.previews.h + "px",
              overflow: "hidden",
              zoom: 240 / this.previews.w
          };
      },
      //放大缩小,正数放大,负数缩小
      changeScale(num){
        this.$refs.cropper.changeScale(num);
      },
      //向右旋转图片90°
      rotateRight(){
        this.$refs.cropper.rotateRight();
      },
      //确定裁剪
      getResult(){
        var that = this;
        let w = this.$refs.cropper.cropW;
        let h = this.$refs.cropper.cropH;
        this.$refs.cropper.getCropData(data=>{
            //let img = window.URL.createObjectURL(data);
            let img = data;
            that.resultUrl = img;
            that.$emit('changeCrop',{isShow: false, url: img, width: w, height: h});
            that.resetCrop();
        });
      },
      //取消裁剪
      cancelCrop(){
        this.resultUrl = "";
        this.$emit('changeCrop',{isShow: false, url: this.resultUrl});
        this.resetCrop();
      },
      //重置crop
      resetCrop(){
        this.resultUrl = "";
        this.options.img = "";
        this.previews.url = "";
        this.previews = {};
        this.previewStyle = {};
      },
      //检测是否为图片
        testImg(file){
            var res = /\.(jpe?g|png|gif|webp|bmp)/;
            if(res.test(file.name)){
                return true;
            }
            return false;
        },
        //关闭提示框
        closeWarn(data){
            this.$refs.warn.closeWarn();
        },
  }
}
</script>
<style scoped>
.dialog{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgba(0,0,0,.6);
}
.model{
    position: absolute;
    width: 756px;
    height: 536px;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    margin-left: -378px;
    margin-top: -268px;
    background-color: #fff;
    border-radius: 5px;
}
.model>h3{
    line-height: 44px;
    height: 44px;
    border-bottom: 1px solid #e7e7e7;
    padding: 0 35px;
}
.close{
    font-size: 24px;
    cursor: pointer;
}
.crop-info{
    line-height: 40px;
}
.crop-info, .crop-box{
    padding: 0 35px;
    color: #999;
}
.crop-box .left{
    width: 420px;
}
.crop-box .cropper{
    height: 310px;
    position: relative;
}
.crop-box .left-up{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    background-color: #f2f3f4;
}
.crop-box .ft12{
    font-size: 12px;
    margin-top: 20px;
}
.crop-box .add{
    width: 40px;
    height: 40px;
    line-height: 36px;
    border-radius: 50%;
    background-color: #ff9933;
    color: #fff;
    font-size: 36px;
    display: inline-block;
    margin-bottom: 5px;
}
.crop-box .file{
    display: none;
    opacity: 0;
}
.handle{
    line-height: 40px;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}
.handle-icon{
    display: inline-block;
    width: 14px;
    height: 13px;
    margin-left: 15px;
    cursor: pointer;
}
.enlarge{
    background: url(../../assets/img/enlarge_icon.png) no-repeat;
}
.enlarge.active{
    background: url(../../assets/img/enlarge_icon.png) no-repeat;
}
.shrink{
    background: url(../../assets/img/shrink_icon.png) no-repeat;
}
.shrink.active{
    background: url(../../assets/img/shrink_icon_h.png) no-repeat;
}
.rotate{
    background: url(../../assets/img/rotate_icon.png) no-repeat;
}
.rotate.active{
    background: url(../../assets/img/rotate_icon_h.png) no-repeat;
}
.re-up{
    color: #d47f52;
    cursor: pointer;
}
.crop-box .right{
    width: 240px;
    line-height: 40px;
}
.prev{
    box-shadow:  0 0 2px #eee;
}
.prev-box {
    height: 180px;
    background-color: #f2f3f4;
}
.prev-img{
    display: block;
}
.title{
    color: #333;
}
.title, .num-box{
    padding-left: 14px; 
    height: 40px;
}
.num-box{
    color: #ccc;
    font-size: 10px;
    border-bottom: 1px solid #ececec;
}
.num-box img{
    vertical-align: middle;
}
.num-box .icon2{
    margin-left: 30px;
}
.info{
    height: 48px;
    padding: 0 14px;
    justify-content: space-between;
    align-items: center;
    font-size: 10px;
}
.user-img{
    width: 30px;
    height: 30px;
    display: block;
    border-radius: 50%;
    background-color: #e7e7e7;
}
.user-text{
    color: #666;
}
.user-name{
    display: block;
    width: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.btn-box{
    height: 100px;
    border-top: 1px solid #e7e7e7;
    justify-content: center;
    align-items: center;
}
.btn{
    width: 24%;
    height: 40px;
    text-align: center;
    line-height: 38px;
    border-radius: 20px;
    box-sizing: border-box;
    border: 1px solid #ff9933;
    cursor: pointer;
}
.btn-sure{
    background-color: #ff9933;
    color: #fff;
}
.btn-sure:hover{
    background-color: #ff8833;
}
.btn-cancel{
    color: #999;
    margin-left: 5%;
}
.btn-cancel:hover{
    background-color: #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/components/common/cropper.vue